import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import ReactPlayer from "react-player";
import axios from "axios";
import swal from "sweetalert";
import { Markup } from "interweave";
import { serverInfo } from "../../../../App";
import { useContext } from "react";

// page-no-448
function LearningLiveSession(props) {
  const { videoCdnUrl } = useContext(serverInfo);
  const [events, setEvents] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [allSelectedVideo, setAllSelectedVideo] = useState([]);
  const [comment, setComment] = useState("");
  const [mark, setMark] = useState("");

  useEffect(() => {
    const id = props.event?.id;

    axios.get(`/api/star/learning_session/assignment/${id}`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.event);
        setAllSelectedVideo(res.data.approved_event);
      }
    });
  }, [props]);

  const handleSelectedVideo = (event) => {
    setSelectedVideo(event);
  };

  const approvalWithMarkHandler = () => {
    if (mark === "" || mark < 1) {
      swal("Warning", "Minimum Mark 01 Required", "warning");
    } else {
      const fData = new FormData();
      fData.append("comment", comment);
      fData.append("mark", mark);
      const type = "approve";

      axios
        .post(
          `/api/star/learning_session/assignment/approval/${type}/${selectedVideo.id}`,
          fData
        )
        .then((res) => {
          if (res.data.status === 200) {
            setMark(0);
            setComment("");

            //insert
            setAllSelectedVideo((oldArray) => [
              ...oldArray,
              {
                ...selectedVideo,
                mark: mark,
              },
            ]);

            //spice
            const currentIndex = events.indexOf(selectedVideo);
            const newChecked = [...events];
            newChecked.splice(currentIndex, 1);
            setEvents(newChecked);
          }
        });
    }
  };

  return (
    <>
      <div className="AS">
        <div className="row mb-4">
          <div className="col-md-12">
            <div className="card card-bg shadow border-warning">
              <div className="card-body">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Nav variant="pills" className="d-flex">
                    <div className="col-md-12">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="first"
                          className="TabCardGold py-2 text-decoration-none text-center fw-bold px-2 ms-2"
                        >
                          <h4 className="">Learning Session Marking</h4>
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <div className="col-md-12 mt-3">
                        <div className="card card-bg shadow">
                          <div className="card-body">
                            <h5 className="text-warning">
                              Upload Video Instruction
                            </h5>
                            <div className="under-line"></div>
                            <p className="text-light mt-2">
                              <Markup
                                content={props.event?.instruction}
                              ></Markup>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 me-2">
                        <div className="bg-dark py-2 mx-2 mt-4">
                          <h4 className="text-warning">All User Videos</h4>
                        </div>

                        <div className="row my-3 ">
                          {events &&
                            events.map((event, index) => (
                              <div
                                className="col-md-4 mb-3 vide-w"
                                onClick={() => handleSelectedVideo(event)}
                              >
                                <div className="mx-1">
                                  <video
                                    className="VIDEO-x"
                                    controls
                                    src={
                                      event.video != null
                                        ? videoCdnUrl + event.video
                                        : null
                                    }
                                    style={
                                      selectedVideo.id === event.id
                                        ? {
                                            border: "1px solid gold",
                                            borderRadius: "20px",
                                            cursor: "pointer",
                                          }
                                        : {
                                            cursor: "pointer",
                                          }
                                    }
                                  ></video>
                                </div>
                              </div>
                            ))}
                        </div>

                        <div className="d-flex justify-content-center mb-5">
                          <div className="row">
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="form-control inputBorderCreate"
                                placeholder="Write Comment Here...."
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                              />
                            </div>

                            <div className="col-md-4 star-vid-sub">
                              <input
                                type="number"
                                className="form-control inputBorderCreate mark-db"
                                placeholder="enter marks"
                                value={mark}
                                onChange={(e) => setMark(e.target.value)}
                              />
                            </div>

                            <div className="col-md-2">
                              <button
                                type="button"
                                className="btn btn-info px-4 fw-bold submit-btn"
                                onClick={approvalWithMarkHandler}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <hr
                          style={{
                            color: "white",
                            backgroundColor: "white",
                            height: 2,
                            borderColor: "white",
                          }}
                        />

                        <div className="row mb-3">
                          <h5 className="text-light">
                            Marked Videos (
                            {allSelectedVideo && allSelectedVideo.length})
                          </h5>
                        </div>
                        <div className="row mb-3">
                          {allSelectedVideo &&
                            allSelectedVideo.map((event, index) => (
                              <>
                                <div
                                  className="col-md-4 mb-3 vide-w"
                                  onClick={() => handleSelectedVideo(event)}
                                >
                                  <div className="mx-1">
                                    <video
                                      className="VIDEO-x"
                                      controls
                                      src={
                                        event.video != null
                                          ? videoCdnUrl + event.video
                                          : null
                                      }
                                    ></video>
                                    <p className="text-light">
                                      Mark: <strong>{event.mark}</strong>
                                    </p>
                                  </div>
                                </div>
                              </>
                            ))}
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LearningLiveSession;
